module.exports = __webpack_public_path__ + "static/media/11_plantilla_menu_comida_9.b8a5e972.png";